document.documentElement.classList.remove('no-js');

class KairosVariantPicker extends HTMLElement {
  connectedCallback() {
    this.form = this.closest('form');
    this.selects = [...this.querySelectorAll('select[data-option-position]')];
    this.variantInput = this.form?.querySelector('input[name="id"]');
    this.variants = JSON.parse(this.querySelector('script[type="application/json"]')?.textContent || '[]');
    this.price = document.querySelector('[data-product-price]');
    this.comparePrice = document.querySelector('[data-compare-price]');
    this.addButton = this.form?.querySelector('[name="add"]');
    this.addButtonText = this.addButton?.querySelector('[data-add-text]');

    this.selects.forEach((select) => select.addEventListener('change', () => this.updateVariant()));
  }

  updateVariant() {
    const options = this.selects.map((select) => select.value);
    const variant = this.variants.find((item) =>
      item.options.every((option, index) => option === options[index])
    );

    if (!variant) {
      this.variantInput.value = '';
      this.setButton(false, 'Unavailable');
      return;
    }

    this.variantInput.value = variant.id;
    this.setButton(variant.available, variant.available ? 'Add to basket' : 'Sold out');

    if (this.price) this.price.textContent = this.formatMoney(variant.price);
    if (this.comparePrice) {
      const showCompare = variant.compare_at_price && variant.compare_at_price > variant.price;
      this.comparePrice.textContent = showCompare ? this.formatMoney(variant.compare_at_price) : '';
      this.comparePrice.hidden = !showCompare;
    }

    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url);
  }

  setButton(enabled, text) {
    if (!this.addButton) return;
    this.addButton.disabled = !enabled;
    if (this.addButtonText) this.addButtonText.textContent = text;
  }

  formatMoney(cents) {
    const currency = document.documentElement.dataset.currency || 'AUD';
    return new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(cents / 100);
  }
}

if (!customElements.get('kairos-variant-picker')) {
  customElements.define('kairos-variant-picker', KairosVariantPicker);
}

document.addEventListener('click', (event) => {
  document.querySelectorAll('details[open]').forEach((details) => {
    if (!details.contains(event.target)) details.removeAttribute('open');
  });
});
